import { NUMBERS_SUPPORTED_COUNTRIES_LOADING, NUMBERS_SUPPORTED_COUNTRIES_SUCCESS, NUMBERS_SUPPORTED_COUNTRIES_FAILED } from '../actions/numbersSupportedCountries.action';
import { NumberSupportedCountriesReducer } from '../models/numberSupportedCountries.interface';

const initialState: NumberSupportedCountriesReducer = {
    numberSupportedCountriesData: [],
    numberSupportedCountriesLoading: false,
    numberSupportedCountriesError: false,
    numberSupportedCountriesErrorMsg: ''
}

const numberSupportedCountriesReducer = (state: NumberSupportedCountriesReducer = initialState, action: any): NumberSupportedCountriesReducer => {

    switch (action.type) {
        case NUMBERS_SUPPORTED_COUNTRIES_LOADING:
            return {
                ...state,
                numberSupportedCountriesLoading: true,
                numberSupportedCountriesError: false
            }
        case NUMBERS_SUPPORTED_COUNTRIES_SUCCESS:
            return {
                ...state,
                numberSupportedCountriesLoading: false,
                numberSupportedCountriesError: false,
                numberSupportedCountriesData: action.payload.res
            }
        case NUMBERS_SUPPORTED_COUNTRIES_FAILED:
            return {
                ...state,
                numberSupportedCountriesLoading: false,
                numberSupportedCountriesError: true,
                numberSupportedCountriesErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default numberSupportedCountriesReducer;